import { useQuery } from '@tanstack/react-query';
import { fetchRetainerAgreementsByLawFirm } from '@/services/LegalDocumentService';

export function useRetainerAgreements(lawFirmId?: number) {
    return useQuery({
        queryKey: ['retainerAgreements', lawFirmId],
        queryFn: async () => {
            if (!lawFirmId) return [];
            return fetchRetainerAgreementsByLawFirm(lawFirmId);
        },
        enabled: !!lawFirmId,
        staleTime: 5 * 60_000,
    });
}
